// src/App.js
import React, { useState, useEffect } from 'react';
import HomePage from './components/HomePage';
import CheckiePage from './components/CheckiePage';

const App = () => {
  const [currentPage, setCurrentPage] = useState('checkie');

  // Scroll to top whenever the page changes - instant, no animation
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage setCurrentPage={setCurrentPage} />;
      case 'checkie':
        return <CheckiePage setCurrentPage={setCurrentPage} />;
      default:
        return <HomePage setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div className="min-h-screen">
      {renderCurrentPage()}
    </div>
  );
};

export default App;